<template>
    <v-ons-list-item @click="show_alert = true" modifier="chevron">
        <span class="warning-text">
            <i class="fal fa-leaf" aria-hidden="true"></i>
            Important allergy information
        </span>
        <v-ons-alert-dialog
                title="Allergy information"
                v-bind:visible.sync="show_alert"
                v-bind:footer="buttons">
            <template v-if="helpers.stringEmpty(message)">
                If you or someone you are ordering for has any food allergies, please contact the store
                before ordering to enquire about allergens in menu items and food preparation.
            </template>
            <template v-else>
                <span class="alert-dialog-message">{{ message }}</span>
            </template>
        </v-ons-alert-dialog>
    </v-ons-list-item>
</template>

<script>
    export default {
        name: "allergy_warning_list_item",

        props: [
            'phone',
            'message',
            'link',
        ],

        data(){
            return {
                app: this.$root.$data.app,
                show_alert: false,
            }
        },

        methods: {
            callStore(){
                if (this.phone == null){
                    this.$ons.notification.alert('The store has not provided a phone number.', { title: 'Unable to call' })
                } else {
                    this.app.openPhone(this.phone)
                }
            }
        },

        computed: {
            buttons(){
                const buttons = {
                    'Close': () => this.show_alert = false,
                    'Call store': () => this.callStore(),
                }

                if (this.helpers.stringEmpty(this.link) == false)
                    buttons['Read more'] = () => this.app.openLink(this.link)

                return buttons
            }
        }
    }
</script>

<style scoped>
    .alert-dialog-message {
        white-space: pre-line;
    }
</style>


// WEBPACK FOOTER //
// src/js/components/fragments/allergy_warning_list_item.vue